import { CookieSyncSupportedBrowserType } from "../types/cookies";

export const CookieSyncExtensionLinks: {
  [k in CookieSyncSupportedBrowserType]: string;
} = {
  Chrome:
    "https://chrome.google.com/webstore/detail/amazon-workspaces-web/mfmlbfjmlojmpkgoilfnfeefmgigdjjj",
  Firefox:
    "https://extension.workspaces-web.com/firefox/AmazonWorkSpacesWeb.xpi",
};

// TODO: Update doc link once ready https://sim.amazon.com/issues/LOWA-12464
export const CookieSyncAdminGuideUrl =
  "https://docs.aws.amazon.com/workspaces-web/latest/adminguide/user-guide";
